import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Course description rules:
 * - Required (handled elsewhere)
 * - Min length (configurable)
 * - Trim leading/trailing spaces
 * - Do not allow only spaces
 * - Allowed characters as per regex
 */

// Update the regex as per your requirement
const descriptionAllowedCharsValidatorRe =
  /^[A-Za-z0-9 .,!?'"()\-&:/\n\r]+$/;

export const descriptionAllowedCharsValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;

    const str = String(value);
    if (!descriptionAllowedCharsValidatorRe.test(str)) {
      return { descriptionAllowedChars: true };
    }
    return null;
  };
};

export const descriptionTrimValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;

    const str = String(value);
    if (str.trim() !== str) {
      return { descriptionTrim: true };
    }
    return null;
  };
};

export const descriptionNoAllSpacesValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined) return null;

    const str = String(value);
    if (str.length > 0 && str.trim().length === 0) {
      // Map to the same UI message as required
      return { required: true };
    }
    return null;
  };
};

export const descriptionMinLengthValidator = (
  minLength: number
): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;

    const trimmed = String(value).trim();
    if (trimmed.length > 0 && trimmed.length < minLength) {
      return {
        descriptionMinLength: {
          requiredLength: minLength,
          actualLength: trimmed.length,
        },
      };
    }
    return null;
  };
};